<div class="tab-pane show active fade details-view-results" role="tabpanel">
  <div class="diaries-tab-row" *ngIf="diaries.length > 1">
    <ul class="nav secondary-tabs">
      <li class="nav-item" *ngFor="let diary of diaries">
        <a class="nav-link" [class.active]="selectedDiaryId === diary.id" (click)="selectDiary(diary.id)">
          {{ getDiaryDisplayName(diary) }}
        </a>
      </li>
    </ul>
  </div>

  <div class="details-view-results-head">
    <div class="buttons-left" *ngIf="isDevelopmentEnv">
      <a class="btn btn-outline btn-outline-slim" style="min-width: auto; width: auto;" (click)="onResetDiary()" *ngIf="diaryConfig && authService.hasPermission(Permissions.PatientEdiaryWrite)">Reset Diary</a>
      <app-split-button
        *ngIf="authService.hasPermission(Permissions.PatientEdiaryWrite)"
        size="sm"
        [actions]="simulateActions"
        (actionSelected)="onSimulateSplitAction($event)">
      </app-split-button>
    </div>

    <a class="btn btn-outline btn-outline-slim" (click)="diaryConfigModal.show()" *ngIf="authService.hasPermission(Permissions.PatientEdiaryWrite)">Settings</a>
    <button type="button" class="btn btn-secondary btn-slim" (click)="onShowAmendRemindersModal()" [disabled]="!shouldShowAmendRemindersButton()" *ngIf="!isIntraDay && !isOnboardingQuestions && authService.hasPermission(Permissions.PatientEdiaryWrite)">Amend Reminders</button>
  </div>

  <table aria-hidden="true" class="details-view-sites with-heading-columns">
    <thead>
    <tr>
      <th>Date</th>
      <th *ngIf="!isOnboardingQuestions && !isIntraDay">Reminder Time</th>
      <th>Timezone</th>
      <th>Date/Time Entered</th>
      <th>Updated By</th>
      <th class="text-center">Email Site?</th>
      <th class="text-center">Site Emailed?</th>
      <td></td>
    </tr>
    </thead>
      <tr *ngFor="let entry of entries">
          <td>{{ entry.date | date: 'd MMM yyyy' }}</td>
        <td *ngIf="!isOnboardingQuestions && !isIntraDay">{{ diaryConfig?.remindersEnabled || diaryConfig?.emailRemindersEnabled ? getMinutesExpressedAsTime(entry.reminderTimeMinutes) : '-' }}</td>
          <td>{{ getTimezoneWithOffset(entry.timezone) }}</td>
          <td>{{ formatSubmittedDateTime(entry) }}</td>
        <td>{{ entry.updatedBy || '-' }}</td>
        <td class="text-center">
          @if (entry.emailSiteRuleMatched) {
            <i class="fas fa-check" style="color: #00b958;"></i>
          } @else {
            -
          }
        </td>
        <td class="text-center">
          @if (entry.emailSiteRuleMatched) {
            @if (entry.emailSentToSite) {
              <i class="fas fa-check" style="color: #00b958;"></i>
            } @else {
              <i class="fas fa-times" style="color: #D44618;"></i>
            }
          } @else {
            -
          }
        </td>
          <td>
            <div class="buttons">
              @if (entry.submittedDate) {
                <app-button text="View" type="button" size="sm" variant="primary" (clicked)="ediaryEntryModal.showEntry(entry.id)" />
              }

              @if (shouldShowEditEntryButton(entry)) {
                <app-button text="Edit" type="button" size="sm" variant="secondary" (clicked)="ediaryEntryModal.showEdit(entry.id)" />
              }

              @if (isDevelopmentEnv && entry.submittedDate && authService.hasPermission(Permissions.PatientEdiaryWrite)) {
                <app-button text="Remove"
                            type="button"
                            size="sm"
                            variant="info"
                            class="btn-light"
                            (clicked)="onShowDeleteModal(entry)" />
              }
            </div>
          </td>
      </tr>
    <tbody>
    </tbody>
  </table>

  <!-- Add no results and pagination -->
</div>

<app-ediary-config-modal #diaryConfigModal [hasSubmissions]="hasSubmissions" [patientTrialId]="patientTrialId" [formId]="selectedDiaryId" [isOnboardingQuestions]="isOnboardingQuestions" [isIntraDay]="isIntraDay" (changed)="onDiaryConfigChanged()"></app-ediary-config-modal>

<app-patient-ediary-entry-modal #ediaryEntryModal [patientTrialId]="patientTrialId" (saved)="onDiaryEntrySaved()" />

<app-confirm-action-modal
  #confirmDeleteModal
  title="Remove E-Diary Entry"
  message="Are you sure you want to remove this e-diary entry?"
  confirmBtnText="Remove"
  (confirmed)="onConfirmDelete($event)"
  (notConfirmed)="onCancelDelete()">
</app-confirm-action-modal>

<!-- Start: Amend Reminders Modal -->
<app-modal #reminderModal class="amend-dosage-modal">
  <div class="modal-header">
    <h2 class="modal-title">Amend Reminders</h2>
    <button type="button" class="close" (click)="reminderModal.hide()" aria-label="Close">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="reminderForm">

      <div class="start-end-dates" *ngIf="!isOnboardingQuestions">
        <div class="field-group">
          <div class="field-group-inner">
            <label>Apply Reminders From</label>
            <div class="input-wrap">
              <app-datepickerv2-input [parentForm]="reminderForm" controlName="startDate"></app-datepickerv2-input>
            </div>
          </div>
        </div>
      </div>

      <div class="timezone-dose-time">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Timezone</label>
              <app-timezone-select #timezoneSelect (optionChanged)="onTimezoneChanged($event)" [parentForm]="reminderForm" controlName="timezone"></app-timezone-select>
            </div>
          </div>
        </div>

        <div class="field-group">
          <div class="field-group-inner">
            <label>Reminder Time</label>
            <div class="input-wrap">
              <div class="input-wrap type-time">
                <mat-form-field>
                  <input type="time" matInput formControlName="reminderTime">
                </mat-form-field>
              </div>
            </div>
          </div>
          <span class="helper-text" *ngIf="shouldShowUtcTime('reminderTime')">{{ reminderForm.get('reminderTimeUtc').value }} UTC</span>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="onReminderFormSubmit()" [disabled]="reminderForm.invalid || reminderForm.get('isBusy').value" class="btn btn-primary">
      <span *ngIf="reminderForm.get('isBusy').value">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </span>
      <span *ngIf="!reminderForm.get('isBusy').value">Update</span>
    </button>
  </div>
</app-modal>
<!-- End: Amend Reminders Modal -->
